import functions from './functions.js';
import Slider from "./Slider";

$(() => {

    functions.setFormData($('.form-objectName')[0], functions.getUrlData(true));
    functions.setFormData($('.form-objectName')[1], functions.getUrlData(true));
    $('.form-objectName').on('submit', e => {
        e.preventDefault();

        const language = functions.getLang();
        let slug = '/en/accommodation/';
        let params = functions.getFormData($(e.target));
        params = $.param(params);

        if(language == 'hr') {
            slug = '/hr/smjestaj/';
        } else if(language == 'de') {
            slug = '/de/unterkunft/';
        }
        location = slug + '#' + params;
    });

    const $homeMenu = $('.home.main-menu');
    const $otherMenu = $('.other.main-menu');
    document.addEventListener('scroll', e => {
        if(window.scrollY > 0) {
            if($homeMenu[0]) {
                $homeMenu.addClass('bg-dark');
            }
            if($otherMenu[0]) {
                $otherMenu.addClass('position-fixed');
            }
        } else {
            if($homeMenu[0]) {
                $homeMenu.removeClass('bg-dark');
            }
            if($otherMenu[0]) {
                $otherMenu.removeClass('position-fixed');
            }
        }
    });

    let homeHeroSlider = [];
    $('#home-hero-slider').each((i, elem) => {
        homeHeroSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: true,
            arrows: true,
            duration: 1000,
            autoplay: 3000,
            //pauseOnHover: true,
        });
    });

    let homeSpecialOfferSlider = [];
    const slidesPerView = 3;
    $('[id^=home-special-offer-slider]').each((i, elem) => {
        const length = $(elem).find('.keen-slider__slide').length;
        homeSpecialOfferSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: true,
            arrows: true,
            slidesPerView: slidesPerView,
            spacing: 16,
            duration: 1000,
            autoplay: length > slidesPerView ? 3000 : 0,
            pauseOnHover: true,
            breakpoints: {
                '(max-width: 1000px)': {
                    slidesPerView: 1,
                    spacing: 0,
                },
            },
        });
    });

    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = functions.cleanDate(new Date);
    if ( now > displayDate ) {
        displayDate = now;
    }

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-angle-left pr-2"></i>',
            nextArrow: '<i class="la la-angle-right pl-2"></i>',
            onChange(selectedDates, dateStr, instance) {

                const $first = $(instance.input);
                // prevent other logic if second datepicker is triggered by first
                if (instance._openByFirst) {
                    delete instance._openByFirst;
                    return;
                }
                
                if ($first.attr('data-firstDate')) {
                    const $second = $first.closest('form').find('[data-secondDate]').closest('.datepicker');
                    if ($second.length) {

                        var firstDate = new Date(selectedDates[0]);
                        firstDate.setDate(firstDate.getDate() + 1);
                        
                        var secondInstance = $second[0]._flatpickr;
                        // check if firstDate is invalid
                        if (firstDate.getTime() === firstDate.getTime()) {
                            secondInstance._openByFirst = true;
                            secondInstance.set('minDate', firstDate);
                            if (!secondInstance.selectedDates[0]) {
                                firstDate.setDate(firstDate.getDate() + 6);
                                secondInstance.setDate(firstDate);
                            }
                            secondInstance.open();
                            $(secondInstance.altInput).focus();
                        }
                        else if (secondInstance.selectedDates[0]) {
                            secondInstance.clear();
                        }
                    }
                }
                // check if second date is cleared
                else if ($first.attr('data-secondDate') && !selectedDates[0]) {
                    $first.closest('form').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
                }
            },
            onOpen(selectedDates, dateStr, instance) {
                if (instance.input.getAttribute('data-secondDate')) {
                    const $first = $(instance.input).closest('form').find('[data-firstDate]').closest('.datepicker');
                    if ($first.length) {
                        const firstInstance = $first[0]._flatpickr;
                        if (!firstInstance.input.value) {
                            instance.close();
                            firstInstance.open();
                            firstInstance.altInput.focus();
                            return;
                        }
                    }
                }
                !dateStr && instance.jumpToDate(minDate ? minDate : displayDate);
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    }); 

    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });
    /* end gallery */

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });

    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {
            if (!data.element) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            const count = data.id.split(':').length;
            if (count == 2) {
                $element.addClass('text-primary');
            }
            else if (count == 4) {
                $element.addClass('ml-3 text-secondary');
            }
            else {
                $element.addClass('font-weight-bold');
            }
            return $element;
        }
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent() };
        config.allowClear = $elem.attr('data-allow-clear');

        const data = $elem.attr('data-data');
        if (data) {
            try {
                config.data = JSON.parse(data);
            } catch (e) { }
        }

        if ($elem.attr('data-template')) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }

        if ($elem.attr('data-nosearch') !== undefined) {
            config.minimumResultsForSearch = Infinity;
        }

        const placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';

        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ($elem[0].cleared) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });

    });

    $('#cookie-bar-accept').on('click', function (e) {
        functions.setCookie('cookie_usage', 'accepted', 1);
        $("#cookie-bar").addClass('d-none');
    });
});